// extracted by mini-css-extract-plugin
export default {"bold":"styles-bold-bb8778","link":"styles-link-d33166","popOutIcon":"styles-popOutIcon-a2dab5"};